import { useMemo } from "react";
import { getTextColor } from "./colorContrast";


export function useTextColor(backgroundColor: string): string {
  return useMemo(() => getTextColor(backgroundColor), [backgroundColor]);
}